<template>
  <v-row class="mx-2">
    <v-col :style="{ 'padding-left': padding }">
      <v-col
        cols="12"
        md="8"
        sm="6"
        xs="4"
        style="max-width: 100%"
        class="d-flex justify-space-between mx-auto"
      >
        <v-btn color="info" text class="my-auto pl-0" @click="goToSchedule">
          <v-img
            src="@/assets/icons/anterior.png"
            style="cursor: pointer"
            alt="anterior"
            max-width="30"
            max-height="30"
            dark
          />{{ titleItem }}
        </v-btn>
      </v-col>
      <v-card class="card_container mx-auto primary">
        <v-card-title class="d-flex justify-space-between">
          <v-text-field
            dense
            solo
            v-model="search"
            append-icon="mdi-magnify"
            :label="$tc('commons.search')"
            single-line
            hide-details
            class="search"
          />
          <v-col cols="auto" class="my-n4 pr-0">
            <v-row class="ma-0 pa-0">
              <!-- Título -->
              <h3 class="secondary--text mr-4 my-auto" v-show="title">
                {{ title }}
              </h3>
              <v-row class="justify-start border ma-0">
                <!-- Botón de Refresh -->
                <v-col cols="auto pa-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="refreshItems"
                        class="btn-table ma-1"
                        small
                      >
                        <v-icon
                          :class="{ loader: loading4 }"
                          :loading="loading4"
                          :disabled="loading4"
                          id="icon-add"
                          class="mx-auto"
                          size="19"
                        >
                          fas fa-sync-alt
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $tc("commons.refresh") }}</span>
                  </v-tooltip>
                </v-col>

                <!-- Botón de Añadir -->
                <v-col cols="auto pa-0">
                  <div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="white"
                          dark
                          icon
                          class="btn-table ma-1"
                          small
                        >
                          <v-icon
                            size="20"
                            class="mx-auto"
                            id="icon-add"
                            v-bind="attrs"
                            v-on="on"
                            @click="openAdd"
                          >
                            fas fa-plus
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $tc("commons.add") }}</span>
                    </v-tooltip>
                  </div>
                </v-col>
              </v-row>
            </v-row>
          </v-col>
        </v-card-title>
        <v-divider class="mt-1"></v-divider>
        <v-data-table
          :headers="headers"
          :items="paginatedItems"
          :single-expand="true"
          :expanded.sync="expanded"
          :title="title"
          item-key="name"
          show-expand
          hide-default-footer
          :search="search"
          class="mx-auto"
          @item-expanded="onExpand"
          fixed-header
          :height="calculateMaxHeight"
          @refreshItems="refreshItems"
        >
          <!-- Fila expandida -->
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers?.length" style="padding: 0px">
              <v-simple-table style="width: 100%">
                <thead>
                  <tr>
                    <th class="th__title">{{ $tc("schedules.instance") }}</th>
                    <th class="th__title">{{ $tc("schedules.fecDesde") }}</th>
                    <th class="th__title">{{ $tc("schedules.fecHasta") }}</th>
                    <th class="th__title">{{ $tc("schedules.segmDespl") }}</th>
                    <th class="th__title">
                      {{ $tc("schedules.numSecuencia") }}
                    </th>
                    <th class="th__title">{{ $tc("schedules.actions") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(inst, index) in instancias" :key="index">
                    <td>{{ inst.segmNombre }}</td>
                    <td>{{ inst.fecDesde }}</td>
                    <td>{{ inst.fecHasta }}</td>
                    <td>{{ inst.segmDespl }}</td>
                    <td>{{ inst.numSecuencia }}</td>
                    <td>
                      <div
                        width="100px"
                        style="
                          width: 50px;
                          display: flex;
                          justify-content: space-between;
                        "
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <v-icon id="icon-edit" @click="openEdit(inst)"
                                >fas fa-pen</v-icon
                              >
                            </span>
                          </template>
                          <span>{{ $tc("editRegistrations.edit") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <v-icon id="icon-delete" @click="showDelete(inst)"
                                >fas fa-trash</v-icon
                              >
                            </span>
                          </template>
                          <span>{{ $tc("editRegistrations.delete") }}</span>
                        </v-tooltip>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <v-row class="ma-0 pa-0" justify="center">
        <v-col cols="12" md="8" lg="6">
          <v-pagination
            v-if="groups?.length > 0"
            class="paginado ma-0 pa-0"
            v-model="currentPage"
            :length="totalPages"
            prev-icon="mdi-chevron-left"
            next-icon="mdi-chevron-right"
            hide-delimiter-background
            :items-per-page="limit"
            @input="changePage"
          />
        </v-col>
      </v-row>
    </v-col>

    <v-dialog
      v-model="openGroup"
      max-width="600px"
      persistent
      @keydown.esc="cancel"
    >
      <v-card max-width="600px">
        <v-card-title
          style="display: flex; justify-content: center"
          class="mb-5"
        >
          {{ mode }}
        </v-card-title>
        <v-alert
          dense
          v-if="error"
          color="red"
          elevation="5"
          outlined
          text
          type="error"
          align="center"
          class="mr-1 ml-1"
        >
          {{ alertValidate }}</v-alert
        >
        <v-form
          @submit.prevent="validation"
          class="ml-5 mr-5"
          ref="form"
          v-model="valid"
        >
          <date-with-check :showCheck="true" class="mb-4" />
          <v-select
            required
            :rules="rules"
            label="Segmento"
            dense
            outlined
            v-model="data.segment"
            :items="segment"
            item-value="segmId"
            item-text="segment"
            @change="changeSegment"
          />
          <v-text-field
            :label="$tc('changeSchedule.sequenceNumber')"
            dense
            outlined
            v-model="data.sequenceNumber"
            disabled
          />

          <v-text-field
            v-model="data.initialDay"
            :label="$tc('changeSchedule.initialDay')"
            outlined
            dense
            type="number"
            :max="initialDay"
            :min="1"
            :disabled="changeSeg"
            :rules="rulesDays"
          />

          <v-autocomplete
            :rules="rules"
            :label="$tc('schedules.groups')"
            outlined
            v-model="data.groups"
            :items="getAllGroups"
            multiple
            item-value="groupId"
            item-text="name"
            v-if="typeForm == 'add'"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 3">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="index === 3" class="grey--text text-caption">
                (+ {{ data.groups.length - 3 }} )
              </span>
            </template>
          </v-autocomplete>
          <div class="d-flex justify-space-between pb-4">
            <v-btn class="bt-exit" @click="cancel">{{
              $tc("editRegistrations.cancel")
            }}</v-btn>
            <v-btn type="submit" class="bt-acept">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-form>
      </v-card>
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import schedules from "@/store/horarios/schedules";
import groups from "@/store/horarios/groups";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Form from "@/components/Complement/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import DateWithCheck from "@/components/Complement/DateWithCheck.vue";
import date from "@/store/common/date";
import moment from "moment";

export default {
  components: {
    DateWithCheck,
    CardsView,
    TableWithSearch,
    ButtonsCardList,
    Form,
    DeleteDialog,
    Snackbar,
  },

  data() {
    return {
      expanded: [],
      search: "",
      title: this.$tc("schedules.groups"),
      titleTable: "Horarios_Grupos",
      color: "",
      titleDelete: "este grupo?",
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
      ],
      maxWidth: "550px",
      valid: true,
      typeForm: "",
      itemToDelete: null,
      itemId: null,
      alert: false,
      textAlert: "",
      data: {
        segment: null,
        initialDay: 1,
        sequenceNumber: null,
        groups: [],
      },
      error: false,
      alertValidate: "",
      initialDay: null,
      changeSeg: true,
      itemEdit: null,
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      ],
      rulesDays: [
        (v) =>
          (v !== null && v !== undefined && v !== "" && this.validateDays(v)) ||
          `El número está fuera del rango. El rango válido es de 1 a ${this.initialDay}`,
      ],
      loading4: false,
      instancias: [],
      groupSelected: null,
      currentPage: 1,
      limit: 20,
    };
  },

  computed: {
    calculateMaxHeight() {
      switch (true) {
        case this.groups?.length > 7:
          return "60vh";
      }
    },
    groups() {
      return groups.state.groups;
    },
    getAllGroups() {
      const allGroups = this.$store.state.changeGroup.group.item;
      const selectedGroupIds = groups.state.groups;
      return allGroups?.filter(
        (groups) => !selectedGroupIds.some((e) => e.id === groups.groupId),
      );
    },
    padding() {
      return schedules.state.paddingNav;
    },
    openGroup: {
      get() {
        return groups.state.openGroup;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    mode: {
      get() {
        return groups.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    openDelete: {
      get() {
        return groups.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    segment() {
      return this.$store.state.changeSchedule.segment;
    },
    validInitialDay() {
      return this.initialDay !== null;
    },
    totalPages() {
      return Math.ceil(this.groups.length / this.limit);
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.limit;
      const end = start + this.limit;
      return this.groups.slice(start, end);
    },
    titleItem() {
      const schedule = schedules.state.schedules.find(
        (schedule) => schedule.id === schedules.state.scheduleId,
      );
      return schedule ? schedule.name : "Horario";
    },
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
    },
    showDelete(item) {
      groups.commit("setOpenDelete", true);
      this.itemToDelete = {
        id: item.id,
        schedule: schedules.state.scheduleId,
        from: moment.utc(item.fecDesde, "DD-MM-YYYY").format("YYYY-MM-DD"),
      };
    },

    async openEdit(item) {
      this.alert = false;
      this.typeForm = "edit";
      this.$store.commit(
        "changeSchedule/setScheduleId",
        schedules.state.scheduleId,
      );
      groups.commit("setScheduleId", schedules.state.scheduleId);
      groups.commit("setMode", this.$tc("schedules.editGroup"));

      await this.$store.dispatch("changeGroup/getGroups");
      await this.$store.dispatch("changeSchedule/getSegment").then(() => {
        this.data = {
          segment: item.segmId,
          initialDay: item.segmDespl,
          sequenceNumber: item.numSecuencia,
          oldFecDesde: moment
            .utc(item.fecDesde, "DD-MM-YYYY")
            .format("YYYY-MM-DD"),
        };
        this.itemEdit = {
          id: item.id,
          name: item.name,
        };
      });

      date.state.dateFrom = moment
        .utc(item.fecDesde, "DD-MM-YYYY")
        .format("YYYY-MM-DD");

      date.state.dateTo = !item.fecHasta
        ? null
        : moment.utc(item.fecDesde, "DD-MM-YYYY").format("YYYY-MM-DD");

      date.state.checkTo = !item.fecHasta ? true : false;
      groups.commit("setOpenGroup", true);
    },

    openAdd() {
      this.alert = false;
      this.typeForm = "add";
      this.$store.commit(
        "changeSchedule/setScheduleId",
        schedules.state.scheduleId,
      );
      groups.commit("setScheduleId", schedules.state.scheduleId);
      this.$store.dispatch("changeSchedule/getSegment").then(() => {
        if (this.$store.state.changeSchedule.segment.length == 0) {
          this.alert = true;
          this.textAlert = this.$tc("schedules.noSegmentAlert");
          this.color = "#FF8D58";
        } else {
          this.$store.dispatch("changeGroup/getGroups");
          groups.commit("setMode", this.$tc("schedules.addGroup"));
          groups.commit("setOpenGroup", true);
        }
      });
    },

    formatGroupInstances(employee) {
      return employee.instans.map((employeed) => {
        return {
          fecDesde: moment.utc(employeed.fecDesde).format("DD-MM-YYYY"),
          fecHasta: employeed.fecHasta
            ? moment.utc(employeed.fecHasta).format("DD-MM-YYYY")
            : "",
          segmNombre: employeed.segmNombre,
          segmDespl: employeed.segmDespl,
          numSecuencia: employeed.numSecuencia,
          segmId: employeed.segmId,
          id: employee.id,
        };
      });
    },
    onExpand({ item, value }) {
      if (!value) {
        this.isLoading = false;
      } else {
        this.isLoading = true;
        this.groupSelected = item;
        this.instancias = this.formatGroupInstances(item);
        this.isLoading = false;
      }
    },
    async refreshItems() {
      this.loading4 = true;
      try {
        await groups.dispatch("getGroups");
      } finally {
        setTimeout(() => {
          this.loading4 = false;
        }, 2000);
      }
    },
    saveForm() {
      switch (this.typeForm) {
        case "add":
          this.addGroup();
          break;
        case "edit":
          this.editGroup();
          break;
        default:
          break;
      }
    },
    validation() {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.saveForm();
      } else {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 3000);

        this.alertValidate = this.$tc("editRegistrations.required");
      }
    },
    initialDays(selectedData) {
      let inicialDay = this.$store.state.changeSchedule.segment.filter(
        (option) => {
          return option.segmId == selectedData;
        },
      );
      return inicialDay[0]?.days;
    },
    changeSegment() {
      this.changeSeg = false;

      this.$store.commit("changeSchedule/setSegmId", this.data.segment);
      this.$store.dispatch("changeSchedule/getSequence").then(() => {
        this.data.sequenceNumber =
          this.$store.state.changeSchedule.numsequence[0].id;
        this.initialDay = this.initialDays(this.data.segment);
      });
    },
    validateDays(value) {
      if (!this.validInitialDay) {
        return true;
      }
      return value >= 1 && value <= this.initialDay;
    },
    goToSchedule() {
      schedules.dispatch("handleShowWindow", "schedule");
    },
    cancel() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      this.$refs.form.resetValidation();
      (this.data = {
        segment: null,
        initialDay: 1,
        sequenceNumber: null,
        groups: [],
      }),
        (this.error = false);
      groups.commit("setOpenGroup", false);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    selectedGroupNames() {
      const names = this.$store.state.changeGroup.group.item
        .filter((item) => this.data.groups.includes(item.groupId))
        .map((item) => item.name);
      return names;
    },
    addGroup() {
      const payload = {
        segment: this.data.segment,
        initialDay: this.data.initialDay,
        sequenceNumber: this.data.sequenceNumber,
        groups: this.data.groups,
        from: date.state.dateFrom,
        to: date.state.dateTo,
        schedule: schedules.state.scheduleId,
        names: this.selectedGroupNames(),
      };

      groups.commit("setNew", payload);
      groups
        .dispatch("new")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc("schedules.addGroupSuccess");
          this.color = "#82A1D0";
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });
      this.cancel();
    },
    editGroup() {
      const payload = {
        segment: this.data.segment,
        initialDay: this.data.initialDay,
        sequenceNumber: this.data.sequenceNumber,
        from: date.state.dateFrom,
        to: date.state.checkTo == true ? null : date.state.dateTo,
        schedule: schedules.state.scheduleId,
        id: this.itemEdit.id,
        name: this.itemEdit.name,
        oldFrom: this.data.oldFecDesde,
      };
      groups.commit("setEdit", payload);
      groups
        .dispatch("edit")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc("schedules.editGroupSuccess");
          this.color = "#82A1D0";

          // Realiza una busqueda del item ya agregado al store, para actualizar sus instancias.
          this.instancias = this.formatGroupInstances(
            groups.state.groups.find((grp) => this.itemEdit.id === grp.id),
          );
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });

      this.cancel();
    },
    deleteItem() {
      groups.commit("setDeleteItem", this.itemToDelete);
      groups
        .dispatch("delete")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc("schedules.deleteGroupSuccess");
          this.color = "#82A1D0";

          // Actualizar sus instancias.
          this.instancias = this.formatGroupInstances(this.groupSelected);
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });
      this.cancelDelete();
    },
    cancelDelete() {
      groups.commit("setOpenDelete", false);
    },
  },
};
</script>
<style scoped>
.border {
  background-color: #1f324a2f;
  border-color: #a5b9d7;
  border-width: 5px;
  border-style: solid;
  border-radius: 25px;
}
.btn-table {
  background-color: #82a1d0;
}
.loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.th__title {
  background-color: #7692bc !important;
  color: white !important;
}
::v-deep .v-data-table-header th {
  background-color: #82a1d0 !important;
}
#icon-add {
  color: #ffffff;
  margin-right: 8px;
}
#icon-edit {
  color: #39537a;
  font-size: 20px;
}
#icon-delete {
  color: #e2504c;
  font-size: 20px;
}
.search {
  max-width: 500px !important;
}
::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
}
</style>
